import { Navigate, } from "react-router-dom"
import { isAuthenticated, isUnique } from "../helpers/helpers"

export const PublicRoute = ({ children }) => {


    return !isAuthenticated() ? children : <Navigate to={isUnique() ? '/visits' : '/induction'} replace />;
}
